import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto close setelah 4 detik (4000ms)
    setTimeout(() => {
      this.close()
    }, 8000)
  }

  close() {
    // Efek fade out sederhana sebelum menghapus elemen
    this.element.classList.add("opacity-0", "translate-x-full")
    setTimeout(() => {
      this.element.remove()
    }, 500) // Tunggu durasi transisi CSS
  }
}